// extracted by mini-css-extract-plugin
export default {"companyContainer":"UP-z","companyImage":"VP-z","container":"WP-z","heading":"XP-z","darkText":"YP-z","smallHeading":"ZP-z","darkBackground":"_P-z","whiteBackground":"aQ-z"};